import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.dialogVisible = false;
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1);
}(Vue);
default_1 = __decorate([Component({
  name: 'Regular'
})], default_1);
export default default_1;